import { render, staticRenderFns } from "./searchTournamentsBlock.vue?vue&type=template&id=d506b69e&scoped=true&"
import script from "./searchTournamentsBlock.vue?vue&type=script&lang=js&"
export * from "./searchTournamentsBlock.vue?vue&type=script&lang=js&"
import style0 from "./searchTournamentsBlock.vue?vue&type=style&index=0&id=d506b69e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d506b69e",
  null
  
)

export default component.exports